import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import getConfig from 'next/config';

import GameLanding from '@routes/GameLanding';

import { LANGUAGE_FR } from '@common/constants/languages';

const { STATIC_IMAGES_DOMAIN } = getConfig().publicRuntimeConfig;

const GameLandingPage = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const url =
    language === LANGUAGE_FR
      ? `${STATIC_IMAGES_DOMAIN}/Splash-Images/Xmas/Calendrier-de-l-avent-Splash-FR.jpg`
      : `${STATIC_IMAGES_DOMAIN}/Splash-Images/Xmas/Adventskalender-Splash-DE.jpg`;

  return (
    <GameLanding
      pageData={{
        title: t(
          'splashGames.adventcalendar.title',
          'Der Adventskalender ist in der Chicorée App verfügbar',
        ),
        lead: t(
          'splashGames.adventcalendar.lead',
          'Lade jetzt die App herunter und profitiere als Chicorée VIP neben dem Adventskalender auch von weiteren Vorteilen.',
        ),
        image: {
          url,
          altText: t(
            'splashGames.adventcalendar.image.alt',
            'advent calendar game image',
          ),
        },
        ogImage: {
          url,
          altText: t(
            'splashGames.adventcalendar.ogImage.alt',
            'advent calendar game image',
          ),
        },
        meta: {
          title: t(
            'splashGames.adventcalendar.meta.title',
            'games advent calendar',
          ),
          description: t('splashGames.adventcalendar.meta.description', ''),
        },
      }}
    />
  );
};

export const getServerSideProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale)),
  },
});

export default GameLandingPage;
